import { useState } from "react";
import css from "./Header.module.css";
import { Link } from "react-router-dom";
import caret from "../../images/caret.png";

const Nav = () => {
  const [showServices, setShowServices] = useState(false);
  const [showResources, setShowResources] = useState(false);

  const toggleResources = () => {
    setShowResources((old) => !old);
  };

  const toggleServices = () => {
    setShowServices((old) => !old);
  };

  return (
    <div className={css.nav_section}>
      {/* <button
        className={css.services_container}
        onMouseEnter={toggleResources}
        onMouseLeave={toggleResources}
        onClick={() => setShowResources(true)}
      >
        Resources
        {showResources && (
          <nav className={css.services} style={{ width: "8.5rem" }}>
            <Link className={css.link} to="/bookkeeping">
              New Business Registration Checklist
            </Link>
            <Link className={css.link} to="/consulting">
              Consulting
            </Link>
            <Link className={css.link} to="/payroll">
              Payroll
            </Link>
            <Link className={css.link} to="/registration">
              Registration
            </Link>
          </nav>
        )}
        <img className={css.caret} src={caret} alt="" />
      </button> */}
      <button
        className={css.services_container}
        onMouseEnter={toggleServices}
        onMouseLeave={toggleServices}
        onClick={() => setShowServices(true)}
      >
        Services
        {showServices && (
          <nav className={css.services}>
            <Link className={css.link} to="/bookkeeping">
              Bookkeeping
            </Link>
            <Link className={css.link} to="/consulting">
              Consulting
            </Link>
            <Link className={css.link} to="/payroll">
              Payroll
            </Link>
            <Link className={css.link} to="/registration">
              Registration
            </Link>
          </nav>
        )}
        <img className={css.caret} src={caret} alt="" />
      </button>
      <a
        className={`${css.cta} ${css.portal}`}
        href="https://crystalclearconsulting.smartvault.com/secure/SignIn.aspx"
        target="_blank"
        rel="noopener noreferrer"
      >
        Client Portal
      </a>
    </div>
  );
};

export default Nav;
